customElements.define('deferred-media', class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.posterButton = this.querySelector('button');
    this.template = this.querySelector('template');
    this.mediaLoaded = false;

    if (this.posterButton) {
      this.posterButton.addEventListener('click', this.loadContent.bind(this));
    }
  }

  loadContent() {
    if (this.mediaLoaded) return;
    const content = this.template.content.cloneNode(true);
    this.appendChild(content);
    this.posterButton.style.display = 'none';
    this.mediaLoaded = true;
  }
});
